module.exports = __webpack_public_path__ + "img/sk_bak.53ad3739.png";